import React from "react";
import CustomSkeleton from "./common/CustomSkeleton";

const ListLoader = () => {
  return (
    <div>
      {[1, 2, 3, 4].map((item) => (
        <div id={String(item)} className="list-item-skeleton">
          <div className="loader-left-container">
          <div>
            <CustomSkeleton
              width="100px"
              height="14px"
              shape="curvedRectangle"
              style={{ float: "left" }}
            />
          </div>
          <div>
            <CustomSkeleton
              width="300px"
              height="14px"
              shape="curvedRectangle"
              style={{ float: "left" }}
            />
          </div>
          <div>
            <CustomSkeleton
              width="400px"
              height="14px"
              shape="curvedRectangle"
              style={{ float: "left" }}
            />
          </div>
          </div>
          
          <div>
          <CustomSkeleton
              width="80px"
              height="28px"
              shape="curvedRectangle"
              style={{marginRight: '20px'}}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListLoader;
